import React from 'react'
import styled from 'styled-components'
import ParseContent from '../shared/ParseContent'

const Section = styled.section`
  position: relative;
  z-index: 5;

  @media (min-width: 992px) {
    margin-top: -181px;
  }

  @media (max-width: 991.98px) {
    margin-top: -3rem;
  }
`

const Box = styled.div`
  position: relative;
  background-color: ${(props) => props.theme.color.main};
  color: #fff;
  margin-inline: auto;
  max-width: 980px;

  /* Notched bottom-right corner */
  &::after {
    position: absolute;
    content: '';
    right: 0;
    bottom: 0;
    width: 0;
    height: 0;
    border-top: 70px solid transparent;
    border-right: 70px solid #fff;
    z-index: 2;
  }

  @media (min-width: 992px) {
    padding: 87px 100px 79px;
  }

  @media (max-width: 991.98px) {
    padding: 2.5rem 1.5rem 3rem;

    &::after {
      border-top-width: 35px;
      border-right-width: 35px;
    }
  }
`

const Subtitle = styled.span`
  display: block;
  color: #d50021;
  font-weight: 700;
  line-height: 25px;
  margin-bottom: 1rem;

  @media (min-width: 992px) {
    font-size: 20px;
  }

  @media (max-width: 991.98px) {
    font-size: 16px;
  }
`

const Title = styled.h2`
  color: #fff;
  font-weight: 500;
  margin-bottom: 22px;

  @media (min-width: 992px) {
    font-size: 50px;
    line-height: 45px;
  }

  @media (max-width: 991.98px) {
    font-size: 32px;
    line-height: 32px;
  }
`

const ARROW =
  "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='8' height='14' viewBox='0 0 8 14' fill='none'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M0 14L8 7L0 0L0 14Z' fill='%23D50021'/%3E%3C/svg%3E\")"

const Description = styled.div`
  font-size: 16px;
  line-height: 25px;

  & p {
    text-align: justify;
    margin-bottom: 0;
  }

  /* The three "pressure points" from the design are a WYSIWYG bullet list,
     each item a bold label followed by a line of body copy. */
  & ul {
    list-style: none;
    display: flex;
    flex-direction: column;
    gap: 24px;
    margin: 32px 0 0;
  }

  & ul li {
    position: relative;
    text-align: left;

    &::before {
      position: absolute;
      content: '';
      top: 6px;
      width: 8px;
      height: 14px;
      background-image: ${ARROW};
      background-repeat: no-repeat;
      background-size: 8px 14px;
    }
  }

  & ul li br {
    display: none;
  }

  & ul li strong {
    display: block;
    font-weight: 700;
    margin-bottom: 9px;
  }

  @media (min-width: 992px) {
    & ul {
      padding-left: 28px;
    }

    & ul li::before {
      left: -28px;
    }
  }

  @media (max-width: 991.98px) {
    & ul {
      padding-left: 22px;
    }

    & ul li::before {
      left: -22px;
    }
  }
`

function HeroIntroLanding({ subtitle, title, description }) {
  return (
    <Section>
      <div className="container">
        <Box>
          {subtitle && <Subtitle>{subtitle}</Subtitle>}
          {title && <Title>{title}</Title>}
          {description && (
            <Description>
              <ParseContent content={description} />
            </Description>
          )}
        </Box>
      </div>
    </Section>
  )
}

export default HeroIntroLanding
